import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSpring, animated } from "@react-spring/web";
import Confetti from "react-confetti";
import { bookRide } from "../../Services/api";
import { io } from "socket.io-client";
import "./SpecialTaskRide.css";
import { LogoutButton } from "../Common/LogoutButton";
import { toast } from "react-toastify";
import { apiFetch } from "../../utils/api";

const SOCKET_URL = process.env.REACT_APP_BASE_URL;

const hours = Array.from({ length: 2 }, (_, i) => i); // 0 to 1 hour
const minutes = Array.from({ length: 60 }, (_, i) => i); // 0 to 59 minutes

const SpecialTaskRide = ({ user }) => {
  const navigate = useNavigate();
  const [selectedHour, setSelectedHour] = useState(0);
  const [selectedMinute, setSelectedMinute] = useState(0);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [estimatedTime, setEstimatedTime] = useState(null);
  const [rideStatus, setRideStatus] = useState("");
  const [rideId, setRideId] = useState(null);
  const [socket, setSocket] = useState(null);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [timeError, setTimeError] = useState("");
  const [rideProgress, setRideProgress] = useState(0);
  const [searchFrom, setSearchFrom] = useState("");
  const [searchTo, setSearchTo] = useState("");
  const [showFromDropdown, setShowFromDropdown] = useState(false);
  const [showToDropdown, setShowToDropdown] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [rideHistory, setRideHistory] = useState([]);
  const minuteScrollRef = useRef(null);
  const hourScrollRef = useRef(null);
  const [vehicleType, setVehicleType] = useState("Forklift");
  const vehicleOptions = ["Forklift", "Crane", "AMR", "Cherry Picker"];
  const [isBooking, setIsBooking] = useState(false);
  const [currentUser, setCurrentUser] = useState(user || null);
  const [userCode, setUserCode] = useState(null);
  const [driverDetails, setDriverDetails] = useState(null);
  const [isRequesting, setIsRequesting] = useState(false);
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [showDriverPopup, setShowDriverPopup] = useState(false);
  const rideIdRef = useRef(null);
  const [confirmCancelRideId, setConfirmCancelRideId] = useState(null);
  const [isWaitingForReassignment, setIsWaitingForReassignment] =
    useState(false);
  const [reassignmentMessage, setReassignmentMessage] = useState("");

  const confirmationSpring = useSpring({
    opacity: showConfirmation ? 1 : 0,
    transform: showConfirmation ? "translateY(0px)" : "translateY(20px)",
    config: { tension: 300, friction: 20 },
  });

  const masterData = [
    { from: "main gate", to: "car parking", time: 3 },
    { from: "main gate", to: "utility building", time: 4 },
    { from: "main gate", to: "south gate", time: 5 },
    { from: "main gate", to: "fgs", time: 6 },
    { from: "main gate", to: "chakan warehouse", time: 5 },
    { from: "main gate", to: "Boiler Bay - 1", time: 5 },
    { from: "main gate", to: "Boiler Bay - 2", time: 5 },
    { from: "main gate", to: "Boiler Bay - 3", time: 6 },
    { from: "main gate", to: "Boiler Bay - 4", time: 6 },
    { from: "main gate", to: "vendor park bay -1", time: 7 },
    { from: "main gate", to: "vendor park bay -2", time: 7 },
    { from: "main gate", to: "vendor park bay -3", time: 8 },
    { from: "main gate", to: "RMS", time: 7 },
    { from: "main gate", to: "rejection yard", time: 8 },
    { from: "main gate", to: "scrap yard", time: 8 },
    { from: "main gate", to: "ssd assembly", time: 6 },
    { from: "main gate", to: "electronics", time: 6 },
    { from: "main gate", to: "canteen", time: 11 },
    { from: "car parking", to: "main gate", time: 3 },
    { from: "car parking", to: "utility building", time: 3 },
    { from: "car parking", to: "south gate", time: 5 },
    { from: "car parking", to: "fgs", time: 5 },
    { from: "car parking", to: "chakan warehouse", time: 4 },
    { from: "car parking", to: "Boiler Bay - 1", time: 5 },
    { from: "car parking", to: "Boiler Bay - 2", time: 5 },
    { from: "car parking", to: "Boiler Bay - 3", time: 5 },
    { from: "car parking", to: "Boiler Bay - 4", time: 6 },
    { from: "car parking", to: "vendor park bay -1", time: 7 },
    { from: "car parking", to: "vendor park bay -2", time: 7 },
    { from: "car parking", to: "vendor park bay -3", time: 7 },
    { from: "car parking", to: "RMS", time: 6 },
    { from: "car parking", to: "rejection yard", time: 8 },
    { from: "car parking", to: "scrap yard", time: 8 },
    { from: "car parking", to: "ssd assembly", time: 6 },
    { from: "car parking", to: "electronics", time: 6 },
    { from: "car parking", to: "canteen", time: 10 },
    { from: "utility building", to: "main gate", time: 4 },
    { from: "utility building", to: "car parking", time: 3 },
    { from: "utility building", to: "south gate", time: 5 },
    { from: "utility building", to: "fgs", time: 5 },
    { from: "utility building", to: "chakan warehouse", time: 4 },
    { from: "utility building", to: "Boiler Bay - 1", time: 5 },
    { from: "utility building", to: "Boiler Bay - 2", time: 5 },
    { from: "utility building", to: "Boiler Bay - 3", time: 5 },
    { from: "utility building", to: "Boiler Bay - 4", time: 6 },
    { from: "utility building", to: "vendor park bay -1", time: 6 },
    { from: "utility building", to: "vendor park bay -2", time: 7 },
    { from: "utility building", to: "vendor park bay -3", time: 7 },
    { from: "utility building", to: "RMS", time: 7 },
    { from: "utility building", to: "rejection yard", time: 7 },
    { from: "utility building", to: "scrap yard", time: 8 },
    { from: "utility building", to: "ssd assembly", time: 6 },
    { from: "utility building", to: "electronics", time: 6 },
    { from: "utility building", to: "canteen", time: 10 },
    { from: "south gate", to: "main gate", time: 5 },
    { from: "south gate", to: "car parking", time: 5 },
    { from: "south gate", to: "utility building", time: 5 },
    { from: "south gate", to: "fgs", time: 5 },
    { from: "south gate", to: "chakan warehouse", time: 6 },
    { from: "south gate", to: "Boiler Bay - 1", time: 7 },
    { from: "south gate", to: "Boiler Bay - 2", time: 7 },
    { from: "south gate", to: "Boiler Bay - 3", time: 8 },
    { from: "south gate", to: "Boiler Bay - 4", time: 8 },
    { from: "south gate", to: "vendor park bay -1", time: 8 },
    { from: "south gate", to: "vendor park bay -2", time: 8 },
    { from: "south gate", to: "vendor park bay -3", time: 8 },
    { from: "south gate", to: "RMS", time: 8 },
    { from: "south gate", to: "rejection yard", time: 7 },
    { from: "south gate", to: "scrap yard", time: 9 },
    { from: "south gate", to: "ssd assembly", time: 9 },
    { from: "south gate", to: "electronics", time: 10 },
    { from: "south gate", to: "canteen", time: 9 },
    { from: "fgs", to: "main gate", time: 6 },
    { from: "fgs", to: "car parking", time: 5 },
    { from: "fgs", to: "utility building", time: 5 },
    { from: "fgs", to: "south gate", time: 5 },
    { from: "fgs", to: "chakan warehouse", time: 3 },
    { from: "fgs", to: "Boiler Bay - 1", time: 4 },
    { from: "fgs", to: "Boiler Bay - 2", time: 4 },
    { from: "fgs", to: "Boiler Bay - 3", time: 5 },
    { from: "fgs", to: "Boiler Bay - 4", time: 5 },
    { from: "fgs", to: "vendor park bay -1", time: 6 },
    { from: "fgs", to: "vendor park bay -2", time: 6 },
    { from: "fgs", to: "vendor park bay -3", time: 5 },
    { from: "fgs", to: "RMS", time: 6 },
    { from: "fgs", to: "rejection yard", time: 6 },
    { from: "fgs", to: "scrap yard", time: 6 },
    { from: "fgs", to: "ssd assembly", time: 6 },
    { from: "fgs", to: "electronics", time: 5 },
    { from: "fgs", to: "canteen", time: 9 },
    { from: "chakan warehouse", to: "main gate", time: 5 },
    { from: "chakan warehouse", to: "car parking", time: 4 },
    { from: "chakan warehouse", to: "utility building", time: 4 },
    { from: "chakan warehouse", to: "south gate", time: 6 },
    { from: "chakan warehouse", to: "fgs", time: 3 },
    { from: "chakan warehouse", to: "Boiler Bay - 1", time: 4 },
    { from: "chakan warehouse", to: "Boiler Bay - 2", time: 4 },
    { from: "chakan warehouse", to: "Boiler Bay - 3", time: 5 },
    { from: "chakan warehouse", to: "Boiler Bay - 4", time: 5 },
    { from: "chakan warehouse", to: "vendor park bay -1", time: 5 },
    { from: "chakan warehouse", to: "vendor park bay -2", time: 5 },
    { from: "chakan warehouse", to: "vendor park bay -3", time: 5 },
    { from: "chakan warehouse", to: "RMS", time: 5 },
    { from: "chakan warehouse", to: "rejection yard", time: 6 },
    { from: "chakan warehouse", to: "scrap yard", time: 6 },
    { from: "chakan warehouse", to: "ssd assembly", time: 4 },
    { from: "chakan warehouse", to: "electronics", time: 4 },
    { from: "chakan warehouse", to: "canteen", time: 5 },
    { from: "Boiler Bay - 1", to: "main gate", time: 5 },
    { from: "Boiler Bay - 1", to: "car parking", time: 5 },
    { from: "Boiler Bay - 1", to: "utility building", time: 5 },
    { from: "Boiler Bay - 1", to: "south gate", time: 7 },
    { from: "Boiler Bay - 1", to: "fgs", time: 4 },
    { from: "Boiler Bay - 1", to: "chakan warehouse", time: 4 },
    { from: "Boiler Bay - 1", to: "Boiler Bay - 2", time: 3 },
    { from: "Boiler Bay - 1", to: "Boiler Bay - 3", time: 3 },
    { from: "Boiler Bay - 1", to: "Boiler Bay - 4", time: 3 },
    { from: "Boiler Bay - 1", to: "vendor park bay -1", time: 4 },
    { from: "Boiler Bay - 1", to: "vendor park bay -2", time: 5 },
    { from: "Boiler Bay - 1", to: "vendor park bay -3", time: 5 },
    { from: "Boiler Bay - 1", to: "RMS", time: 4 },
    { from: "Boiler Bay - 1", to: "rejection yard", time: 5 },
    { from: "Boiler Bay - 1", to: "scrap yard", time: 6 },
    { from: "Boiler Bay - 1", to: "ssd assembly", time: 5 },
    { from: "Boiler Bay - 1", to: "electronics", time: 5 },
    { from: "Boiler Bay - 1", to: "canteen", time: 7 },
    { from: "Boiler Bay - 2", to: "main gate", time: 5 },
    { from: "Boiler Bay - 2", to: "car parking", time: 5 },
    { from: "Boiler Bay - 2", to: "utility building", time: 5 },
    { from: "Boiler Bay - 2", to: "south gate", time: 7 },
    { from: "Boiler Bay - 2", to: "fgs", time: 4 },
    { from: "Boiler Bay - 2", to: "chakan warehouse", time: 4 },
    { from: "Boiler Bay - 2", to: "Boiler Bay - 1", time: 3 },
    { from: "Boiler Bay - 2", to: "Boiler Bay - 3", time: 3 },
    { from: "Boiler Bay - 2", to: "Boiler Bay - 4", time: 4 },
    { from: "Boiler Bay - 2", to: "vendor park bay -1", time: 4 },
    { from: "Boiler Bay - 2", to: "vendor park bay -2", time: 6 },
    { from: "Boiler Bay - 2", to: "vendor park bay -3", time: 6 },
    { from: "Boiler Bay - 2", to: "RMS", time: 6 },
    { from: "Boiler Bay - 2", to: "rejection yard", time: 7 },
    { from: "Boiler Bay - 2", to: "scrap yard", time: 6 },
    { from: "Boiler Bay - 2", to: "ssd assembly", time: 5 },
    { from: "Boiler Bay - 2", to: "electronics", time: 6 },
    { from: "Boiler Bay - 2", to: "canteen", time: 7 },
    { from: "Boiler Bay - 3", to: "main gate", time: 6 },
    { from: "Boiler Bay - 3", to: "car parking", time: 5 },
    { from: "Boiler Bay - 3", to: "utility building", time: 5 },
    { from: "Boiler Bay - 3", to: "south gate", time: 8 },
    { from: "Boiler Bay - 3", to: "fgs", time: 5 },
    { from: "Boiler Bay - 3", to: "chakan warehouse", time: 5 },
    { from: "Boiler Bay - 3", to: "Boiler Bay - 1", time: 3 },
    { from: "Boiler Bay - 3", to: "Boiler Bay - 2", time: 3 },
    { from: "Boiler Bay - 3", to: "Boiler Bay - 4", time: 5 },
    { from: "Boiler Bay - 3", to: "vendor park bay -1", time: 6 },
    { from: "Boiler Bay - 3", to: "vendor park bay -2", time: 6 },
    { from: "Boiler Bay - 3", to: "vendor park bay -3", time: 6 },
    { from: "Boiler Bay - 3", to: "RMS", time: 5 },
    { from: "Boiler Bay - 3", to: "rejection yard", time: 6 },
    { from: "Boiler Bay - 3", to: "scrap yard", time: 6 },
    { from: "Boiler Bay - 3", to: "ssd assembly", time: 3 },
    { from: "Boiler Bay - 3", to: "electronics", time: 5 },
    { from: "Boiler Bay - 3", to: "canteen", time: 7 },
    { from: "Boiler Bay - 4", to: "main gate", time: 6 },
    { from: "Boiler Bay - 4", to: "car parking", time: 6 },
    { from: "Boiler Bay - 4", to: "utility building", time: 6 },
    { from: "Boiler Bay - 4", to: "south gate", time: 8 },
    { from: "Boiler Bay - 4", to: "fgs", time: 5 },
    { from: "Boiler Bay - 4", to: "chakan warehouse", time: 5 },
    { from: "Boiler Bay - 4", to: "Boiler Bay - 1", time: 3 },
    { from: "Boiler Bay - 4", to: "Boiler Bay - 2", time: 4 },
    { from: "Boiler Bay - 4", to: "Boiler Bay - 3", time: 5 },
    { from: "Boiler Bay - 4", to: "vendor park bay -1", time: 6 },
    { from: "Boiler Bay - 4", to: "vendor park bay -2", time: 6 },
    { from: "Boiler Bay - 4", to: "vendor park bay -3", time: 6 },
    { from: "Boiler Bay - 4", to: "RMS", time: 9 },
    { from: "Boiler Bay - 4", to: "rejection yard", time: 10 },
    { from: "Boiler Bay - 4", to: "scrap yard", time: 10 },
    { from: "Boiler Bay - 4", to: "ssd assembly", time: 6 },
    { from: "Boiler Bay - 4", to: "electronics", time: 6 },
    { from: "Boiler Bay - 4", to: "canteen", time: 7 },
    { from: "vendor park bay -1", to: "main gate", time: 7 },
    { from: "vendor park bay -1", to: "car parking", time: 7 },
    { from: "vendor park bay -1", to: "utility building", time: 6 },
    { from: "vendor park bay -1", to: "south gate", time: 8 },
    { from: "vendor park bay -1", to: "fgs", time: 6 },
    { from: "vendor park bay -1", to: "chakan warehouse", time: 5 },
    { from: "vendor park bay -1", to: "Boiler Bay - 1", time: 4 },
    { from: "vendor park bay -1", to: "Boiler Bay - 2", time: 4 },
    { from: "vendor park bay -1", to: "Boiler Bay - 3", time: 6 },
    { from: "vendor park bay -1", to: "Boiler Bay - 4", time: 6 },
    { from: "vendor park bay -1", to: "vendor park bay -2", time: 3 },
    { from: "vendor park bay -1", to: "vendor park bay -3", time: 3 },
    { from: "vendor park bay -1", to: "RMS", time: 3 },
    { from: "vendor park bay -1", to: "rejection yard", time: 4 },
    { from: "vendor park bay -1", to: "scrap yard", time: 3 },
    { from: "vendor park bay -1", to: "ssd assembly", time: 7 },
    { from: "vendor park bay -1", to: "electronics", time: 7 },
    { from: "vendor park bay -1", to: "canteen", time: 9 },
    { from: "vendor park bay -2", to: "main gate", time: 7 },
    { from: "vendor park bay -2", to: "car parking", time: 7 },
    { from: "vendor park bay -2", to: "utility building", time: 7 },
    { from: "vendor park bay -2", to: "south gate", time: 8 },
    { from: "vendor park bay -2", to: "fgs", time: 6 },
    { from: "vendor park bay -2", to: "chakan warehouse", time: 5 },
    { from: "vendor park bay -2", to: "Boiler Bay - 1", time: 5 },
    { from: "vendor park bay -2", to: "Boiler Bay - 2", time: 6 },
    { from: "vendor park bay -2", to: "Boiler Bay - 3", time: 6 },
    { from: "vendor park bay -2", to: "Boiler Bay - 4", time: 6 },
    { from: "vendor park bay -2", to: "vendor park bay -1", time: 3 },
    { from: "vendor park bay -2", to: "vendor park bay -3", time: 3 },
    { from: "vendor park bay -2", to: "RMS", time: 3 },
    { from: "vendor park bay -2", to: "rejection yard", time: 5 },
    { from: "vendor park bay -2", to: "scrap yard", time: 4 },
    { from: "vendor park bay -2", to: "ssd assembly", time: 7 },
    { from: "vendor park bay -2", to: "electronics", time: 6 },
    { from: "vendor park bay -2", to: "canteen", time: 9 },
    { from: "vendor park bay -3", to: "main gate", time: 8 },
    { from: "vendor park bay -3", to: "car parking", time: 7 },
    { from: "vendor park bay -3", to: "utility building", time: 7 },
    { from: "vendor park bay -3", to: "south gate", time: 8 },
    { from: "vendor park bay -3", to: "fgs", time: 5 },
    { from: "vendor park bay -3", to: "chakan warehouse", time: 5 },
    { from: "vendor park bay -3", to: "Boiler Bay - 1", time: 5 },
    { from: "vendor park bay -3", to: "Boiler Bay - 2", time: 6 },
    { from: "vendor park bay -3", to: "Boiler Bay - 3", time: 6 },
    { from: "vendor park bay -3", to: "Boiler Bay - 4", time: 6 },
    { from: "vendor park bay -3", to: "vendor park bay -1", time: 3 },
    { from: "vendor park bay -3", to: "vendor park bay -2", time: 3 },
    { from: "vendor park bay -3", to: "RMS", time: 3 },
    { from: "vendor park bay -3", to: "rejection yard", time: 4 },
    { from: "vendor park bay -3", to: "scrap yard", time: 3 },
    { from: "vendor park bay -3", to: "ssd assembly", time: 6 },
    { from: "vendor park bay -3", to: "electronics", time: 7 },
    { from: "vendor park bay -3", to: "canteen", time: 9 },
    { from: "RMS", to: "main gate", time: 7 },
    { from: "RMS", to: "car parking", time: 6 },
    { from: "RMS", to: "utility building", time: 7 },
    { from: "RMS", to: "south gate", time: 8 },
    { from: "RMS", to: "fgs", time: 6 },
    { from: "RMS", to: "chakan warehouse", time: 5 },
    { from: "RMS", to: "Boiler Bay - 1", time: 4 },
    { from: "RMS", to: "Boiler Bay - 2", time: 6 },
    { from: "RMS", to: "Boiler Bay - 3", time: 5 },
    { from: "RMS", to: "Boiler Bay - 4", time: 9 },
    { from: "RMS", to: "vendor park bay -1", time: 3 },
    { from: "RMS", to: "vendor park bay -2", time: 3 },
    { from: "RMS", to: "vendor park bay -3", time: 3 },
    { from: "RMS", to: "rejection yard", time: 3 },
    { from: "RMS", to: "scrap yard", time: 3 },
    { from: "RMS", to: "ssd assembly", time: 7 },
    { from: "RMS", to: "electronics", time: 7 },
    { from: "RMS", to: "canteen", time: 9 },
    { from: "rejection yard", to: "main gate", time: 8 },
    { from: "rejection yard", to: "car parking", time: 8 },
    { from: "rejection yard", to: "utility building", time: 7 },
    { from: "rejection yard", to: "south gate", time: 7 },
    { from: "rejection yard", to: "fgs", time: 6 },
    { from: "rejection yard", to: "chakan warehouse", time: 6 },
    { from: "rejection yard", to: "Boiler Bay - 1", time: 5 },
    { from: "rejection yard", to: "Boiler Bay - 2", time: 7 },
    { from: "rejection yard", to: "Boiler Bay - 3", time: 6 },
    { from: "rejection yard", to: "Boiler Bay - 4", time: 10 },
    { from: "rejection yard", to: "vendor park bay -1", time: 4 },
    { from: "rejection yard", to: "vendor park bay -2", time: 5 },
    { from: "rejection yard", to: "vendor park bay -3", time: 4 },
    { from: "rejection yard", to: "RMS", time: 3 },
    { from: "rejection yard", to: "scrap yard", time: 3 },
    { from: "rejection yard", to: "ssd assembly", time: 8 },
    { from: "rejection yard", to: "electronics", time: 8 },
    { from: "rejection yard", to: "canteen", time: 10 },
    { from: "scrap yard", to: "main gate", time: 8 },
    { from: "scrap yard", to: "car parking", time: 8 },
    { from: "scrap yard", to: "utility building", time: 8 },
    { from: "scrap yard", to: "south gate", time: 9 },
    { from: "scrap yard", to: "fgs", time: 6 },
    { from: "scrap yard", to: "chakan warehouse", time: 6 },
    { from: "scrap yard", to: "Boiler Bay - 1", time: 6 },
    { from: "scrap yard", to: "Boiler Bay - 2", time: 6 },
    { from: "scrap yard", to: "Boiler Bay - 3", time: 6 },
    { from: "scrap yard", to: "Boiler Bay - 4", time: 10 },
    { from: "scrap yard", to: "vendor park bay -1", time: 3 },
    { from: "scrap yard", to: "vendor park bay -2", time: 4 },
    { from: "scrap yard", to: "vendor park bay -3", time: 3 },
    { from: "scrap yard", to: "RMS", time: 3 },
    { from: "scrap yard", to: "rejection yard", time: 3 },
    { from: "scrap yard", to: "ssd assembly", time: 8 },
    { from: "scrap yard", to: "electronics", time: 8 },
    { from: "scrap yard", to: "canteen", time: 10 },
    { from: "ssd assembly", to: "main gate", time: 6 },
    { from: "ssd assembly", to: "car parking", time: 6 },
    { from: "ssd assembly", to: "utility building", time: 6 },
    { from: "ssd assembly", to: "south gate", time: 9 },
    { from: "ssd assembly", to: "fgs", time: 6 },
    { from: "ssd assembly", to: "chakan warehouse", time: 4 },
    { from: "ssd assembly", to: "Boiler Bay - 1", time: 5 },
    { from: "ssd assembly", to: "Boiler Bay - 2", time: 5 },
    { from: "ssd assembly", to: "Boiler Bay - 3", time: 3 },
    { from: "ssd assembly", to: "Boiler Bay - 4", time: 6 },
    { from: "ssd assembly", to: "vendor park bay -1", time: 7 },
    { from: "ssd assembly", to: "vendor park bay -2", time: 7 },
    { from: "ssd assembly", to: "vendor park bay -3", time: 6 },
    { from: "ssd assembly", to: "RMS", time: 7 },
    { from: "ssd assembly", to: "rejection yard", time: 8 },
    { from: "ssd assembly", to: "scrap yard", time: 8 },
    { from: "ssd assembly", to: "electronics", time: 5 },
    { from: "ssd assembly", to: "canteen", time: 6 },
    { from: "electronics", to: "main gate", time: 6 },
    { from: "electronics", to: "car parking", time: 6 },
    { from: "electronics", to: "utility building", time: 6 },
    { from: "electronics", to: "south gate", time: 10 },
    { from: "electronics", to: "fgs", time: 5 },
    { from: "electronics", to: "chakan warehouse", time: 4 },
    { from: "electronics", to: "Boiler Bay - 1", time: 5 },
    { from: "electronics", to: "Boiler Bay - 2", time: 6 },
    { from: "electronics", to: "Boiler Bay - 3", time: 5 },
    { from: "electronics", to: "Boiler Bay - 4", time: 6 },
    { from: "electronics", to: "vendor park bay -1", time: 7 },
    { from: "electronics", to: "vendor park bay -2", time: 6 },
    { from: "electronics", to: "vendor park bay -3", time: 7 },
    { from: "electronics", to: "RMS", time: 7 },
    { from: "electronics", to: "rejection yard", time: 8 },
    { from: "electronics", to: "scrap yard", time: 8 },
    { from: "electronics", to: "ssd assembly", time: 5 },
    { from: "electronics", to: "canteen", time: 7 },
    { from: "canteen", to: "main gate", time: 11 },
    { from: "canteen", to: "car parking", time: 10 },
    { from: "canteen", to: "utility building", time: 10 },
    { from: "canteen", to: "south gate", time: 9 },
    { from: "canteen", to: "fgs", time: 9 },
    { from: "canteen", to: "chakan warehouse", time: 5 },
    { from: "canteen", to: "Boiler Bay - 1", time: 7 },
    { from: "canteen", to: "Boiler Bay - 2", time: 7 },
    { from: "canteen", to: "Boiler Bay - 3", time: 7 },
    { from: "canteen", to: "Boiler Bay - 4", time: 7 },
    { from: "canteen", to: "vendor park bay -1", time: 9 },
    { from: "canteen", to: "vendor park bay -2", time: 9 },
    { from: "canteen", to: "vendor park bay -3", time: 9 },
    { from: "canteen", to: "RMS", time: 9 },
    { from: "canteen", to: "rejection yard", time: 10 },
    { from: "canteen", to: "scrap yard", time: 10 },
    { from: "canteen", to: "ssd assembly", time: 6 },
    { from: "canteen", to: "electronics", time: 7 },
  ];

  const [rideTimestamps, setRideTimestamps] = useState({});

  // Reset rideTimestamps whenever rideId changes
  useEffect(() => {
    setRideTimestamps({
      creation_time: null,
      start_time: null,
      material_pick_time: null,
      material_drop_time: null,
      end_time: null,
    });
  }, [rideId]);

  // Get all unique locations
  const allLocations = [
    ...new Set([
      ...masterData.map((data) => data.from),
      ...masterData.map((data) => data.to),
    ]),
  ].sort();

  // Filter locations based on search
  const filteredFromLocations = allLocations.filter((loc) =>
    loc.toLowerCase().includes(searchFrom.toLowerCase())
  );

  // const filteredToLocations = allLocations
  //   .filter((loc) => loc !== fromLocation)
  //   .filter((loc) => loc.toLowerCase().includes(searchTo.toLowerCase()));

  const filteredToLocations = allLocations.filter((loc) =>
    loc.toLowerCase().includes(searchTo.toLowerCase())
  );

  const fetchRideTimestamps = async (rideId) => {
    try {
      const result = await apiFetch(`/api/bookings/get-timestamps/${rideId}`);
      const timestamps = result.timestamps || {};
      // console.log("📅 rideTimestamps =", timestamps);

      const fixTimestampFormat = (ts) => ts?.replace(" ", "T") || null;

      const fixedTimestamps = {
        creation_time: fixTimestampFormat(timestamps.creation_time),
        start_time: fixTimestampFormat(timestamps.start_time),
        material_pick_time: fixTimestampFormat(timestamps.material_pick_time),
        material_drop_time: fixTimestampFormat(timestamps.material_drop_time),
        end_time: fixTimestampFormat(timestamps.end_time),
      };

      setRideTimestamps((prev) => ({
        ...prev,
        [rideId]: fixedTimestamps,
      }));
    } catch (error) {
      console.error("❌ Error fetching timestamps:", error);
    }
  };

  const fetchAndSetDriverDetails = async (driverId) => {
    if (!driverId) {
      setDriverDetails(null);
      return;
    }

    try {
      const data = await apiFetch(`/api/drivers/getSpecificDriver/${driverId}`);

      if (data?.driver?.[0]) {
        setDriverDetails(data.driver[0]);
      } else {
        console.warn("No driver found for ID:", driverId);
        setDriverDetails(null);
      }
    } catch (err) {
      console.error("Error fetching driver details:", err);
      setDriverDetails(null);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let confettiTimer;
    if (showConfetti) {
      confettiTimer = setTimeout(() => {
        setShowConfetti(false);
      }, 3000);
    }
    return () => {
      if (confettiTimer) clearTimeout(confettiTimer);
    };
  }, [showConfetti]);

  useEffect(() => {
    if (fromLocation && toLocation) {
      const route = masterData.find(
        (route) => route.from === fromLocation && route.to === toLocation
      );
      if (route) {
        setEstimatedTime(route.time);
      } else {
        setEstimatedTime(null);
      }
    } else {
      setEstimatedTime(null);
    }
  }, [fromLocation, toLocation]);

  useEffect(() => {
    const newSocket = io(SOCKET_URL, {
      autoConnect: true,
      withCredentials: true,
    });
    setSocket(newSocket);

    newSocket.on("connect", () => {
      console.log("✅ Connected to SpecialTaskRide Socket.IO server");
    });

    newSocket.on("disconnect", () => {
      console.log("❌ Disconnected from SpecialTaskRide Socket.IO server");
    });

    newSocket.onAny((event, ...args) => {
      console.log(`📡 Received event: ${event}`, args);
    });

    newSocket.on("rideAccepted", (data) => {
      const { rideId: acceptedRideId, driverData } = data;

      setRideId(acceptedRideId);
      localStorage.setItem("rideId", acceptedRideId);

      setRideStatus("accepted");
      setRideProgress(2);
      setShowConfetti(true);
      setIsRequesting(false);

      if (driverData) {
        setDriverDetails(driverData);
        localStorage.setItem(
          `driverDetails-${acceptedRideId}`,
          JSON.stringify(driverData)
        );
      } else {
        console.warn("⚠️ driverData missing in rideAccepted. Trying fallback.");
        if (data.driverId) {
          fetchAndSetDriverDetails(data.driverId);
        }
      }

      localStorage.removeItem("isRequesting");

      // ✅ Fetch timestamps immediately when ride is accepted
      fetchRideTimestamps(acceptedRideId);

      // ✅ Update the ride history state immediately
      const updatedHistory = [...rideHistory];
      const rideIndex = updatedHistory.findIndex(
        (ride) =>
          ride.RIDE_ID === acceptedRideId || ride.rideId === acceptedRideId
      );

      if (rideIndex !== -1) {
        updatedHistory[rideIndex].STATUS = "ongoing";
        updatedHistory[rideIndex].driverDetails = driverData;
        setRideHistory(updatedHistory);
        localStorage.setItem("rideHistory", JSON.stringify(updatedHistory));
      }

      // ✅ Also fetch from server to ensure consistency
      fetchRideHistory(userCode);
    });

    newSocket.on("rideStarted", async (data) => {
      if (data.rideId === rideIdRef.current) {
        setRideProgress(3);
        await fetchRideTimestamps(data.rideId);

        // ✅ Update both progress timestamps AND history
        updateRideHistoryTimestamp(data.rideId, {
          START_TIME: new Date().toISOString(),
          STATUS: "started",
        });

        // ✅ Also refresh from server to get exact timestamp
        fetchRideHistory(userCode);
      }
    });

    newSocket.on("materialPicked", async (data) => {
      if (data.rideId === rideIdRef.current) {
        setRideProgress(4);
        await fetchRideTimestamps(data.rideId);

        updateRideHistoryTimestamp(data.rideId, {
          MATERIAL_PICKED_TIME: new Date().toISOString(),
          STATUS: "material picked",
        });

        // ✅ Refresh from server
        fetchRideHistory(userCode);
      }
    });

    newSocket.on("materialDropped", async (data) => {
      if (data.rideId === rideIdRef.current) {
        setRideProgress(5);
        await fetchRideTimestamps(data.rideId);

        updateRideHistoryTimestamp(data.rideId, {
          MATERIAL_DROPPED_TIME: new Date().toISOString(),
          STATUS: "delivered",
        });

        // ✅ Refresh from server
        fetchRideHistory(userCode);
      }
    });

    newSocket.on("rideEnded", async (data) => {
      if (data.rideId === rideIdRef.current) {
        setRideProgress(6);
        await fetchRideTimestamps(data.rideId);

        updateRideHistoryTimestamp(data.rideId, {
          END_TIME: new Date().toISOString(),
          TIMESTAMP: new Date().toISOString(),
          STATUS: "completed",
        });

        // ✅ Refresh from server
        fetchRideHistory(userCode);

        setTimeout(() => {
          setRideProgress(0);
          setRideStatus("");
          setFromLocation("");
          setToLocation("");
          setRideId(null);
        }, 5000);
      }
    });

    newSocket.on("rideRedistributed", (data) => {
      if (data.rideId === rideIdRef.current) {
        console.log("🚨 Vehicle breakdown detected (Special Task):", data);

        // Show loading state and message immediately
        setIsWaitingForReassignment(true);
        setReassignmentMessage(
          "Vehicle broke down. Waiting for a new driver..."
        );
        setIsRequesting(true);

        // Update ride progress to show waiting state
        setRideProgress((prev) => prev); // Keep current progress but add loading

        // Update ride status in history
        const updatedHistory = rideHistory.map((ride) =>
          ride.RIDE_ID === data.rideId
            ? { ...ride, STATUS: "waiting_for_reassignment" }
            : ride
        );
        setRideHistory(updatedHistory);
        localStorage.setItem("rideHistory", JSON.stringify(updatedHistory));
      }
    });

    newSocket.on("driverReassigned", (data) => {
      if (data.rideId === rideIdRef.current) {
        console.log("✅ New driver assigned (Special Task):", data);

        // Hide loading state immediately
        setIsWaitingForReassignment(false);
        setIsRequesting(false);
        setReassignmentMessage("");

        // Update driver details immediately with new driver info
        if (data.driverDetails) {
          setDriverDetails({
            OPERATOR_ID: data.driverDetails.id,
            NAME: data.driverDetails.name,
            MOBILE: data.driverDetails.mobile,
            VEHICLE_TYPE: data.driverDetails.vehicle,
          });

          // Store new driver details
          localStorage.setItem(
            `driverDetails-${data.rideId}`,
            JSON.stringify({
              OPERATOR_ID: data.driverDetails.id,
              NAME: data.driverDetails.name,
              MOBILE: data.driverDetails.mobile,
              VEHICLE_TYPE: data.driverDetails.vehicle,
            })
          );
        }

        // Show success message briefly
        setReassignmentMessage(`New driver assigned: ${data.newDriverName}`);
        setTimeout(() => setReassignmentMessage(""), 3000);

        // Update ride status in history
        const updatedHistory = rideHistory.map((ride) =>
          ride.RIDE_ID === data.rideId
            ? { ...ride, STATUS: "ongoing", DRIVER_ID: data.newDriverId }
            : ride
        );
        setRideHistory(updatedHistory);
        localStorage.setItem("rideHistory", JSON.stringify(updatedHistory));

        // Continue tracking ride progress from current state
        fetchRideTimestamps(data.rideId);
      }
    });

    newSocket.on("noAlternativeDriver", (data) => {
      if (data.rideId === rideIdRef.current) {
        toast.info(
          "❌ No alternative drivers available. Please cancel or wait."
        );
      }
    });

    return () => {
      newSocket.disconnect();
      console.log("❌ Disconnected from Socket.IO server");
    };
  }, [rideId]);

  useEffect(() => {
    const handleScroll = (ref, setter, items) => {
      const index = Math.round(ref.current.scrollTop / 40);
      if (index >= 0 && index < items.length) {
        setter(items[index]);
      }
    };

    const minuteScroll = minuteScrollRef.current;
    const hourScroll = hourScrollRef.current;

    const handleMinuteScroll = () =>
      handleScroll(minuteScrollRef, setSelectedMinute, minutes);
    const handleHourScroll = () =>
      handleScroll(hourScrollRef, setSelectedHour, hours);

    if (minuteScroll)
      minuteScroll.addEventListener("scroll", handleMinuteScroll);
    if (hourScroll) hourScroll.addEventListener("scroll", handleHourScroll);

    return () => {
      if (minuteScroll)
        minuteScroll.removeEventListener("scroll", handleMinuteScroll);
      if (hourScroll)
        hourScroll.removeEventListener("scroll", handleHourScroll);
    };
  }, []);

  useEffect(() => {
    const storedUserString = localStorage.getItem("user");

    if (!storedUserString) {
      navigate("/signin", { replace: true });
      return; // make sure to stop execution
    }

    try {
      const storedUser = JSON.parse(storedUserString);
      setCurrentUser(storedUser);
      setUserCode(storedUser.token_no); // Save user code to state
      fetchRideHistory(storedUser.token_no);
    } catch (err) {
      console.error("Failed to parse stored user:", err);
      navigate("/signin", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const storedRideId = localStorage.getItem("rideId");
    if (storedRideId) {
      setRideId(storedRideId);
    }
  }, []);

  useEffect(() => {
    if (!rideId || driverDetails) return;

    const cached = localStorage.getItem(`driverDetails-${rideId}`);
    if (cached && cached !== "undefined") {
      try {
        const parsed = JSON.parse(cached);
        setDriverDetails(parsed);
      } catch (err) {
        console.error("❌ Failed to parse driverDetails:", err);
        localStorage.removeItem(`driverDetails-${rideId}`);
      }
    }
  }, [rideId, driverDetails]);

  useEffect(() => {
    const requesting = localStorage.getItem("isRequesting");
    if (requesting) {
      setIsRequesting(true);
    }
  }, []);

  useEffect(() => {
    rideIdRef.current = rideId;
  }, [rideId]);

  useEffect(() => {
    if (showHistory && rideHistory.length > 0) {
      rideHistory.forEach((ride) => {
        if (ride.RIDE_ID && !rideTimestamps[ride.RIDE_ID]) {
          fetchRideTimestamps(ride.RIDE_ID);
        }
      });
    }
  }, [showHistory, rideHistory]);

  const updateRideHistoryTimestamp = (rideId, fieldsToUpdate = {}) => {
    const updated = rideHistory.map((ride) => {
      if (ride.RIDE_ID === rideId) {
        return { ...ride, ...fieldsToUpdate };
      }
      return ride;
    });

    setRideHistory(updated);
    localStorage.setItem("rideHistory", JSON.stringify(updated));
  };

  const fetchRideHistory = async (userId) => {
    // console.log("userId = ", userId);
    try {
      const data = await apiFetch(`/api/ride-history/user?userId=${userId}`);
      // console.log("ride history = ", data);
      setRideHistory(data.history || []);
    } catch (error) {
      console.error("Error fetching ride history:", error);
    }
  };

  const fetchRideStatus = async (rideId) => {
    try {
      const clickedRide = await apiFetch(`/api/tracking/ride-status/${rideId}`);
      console.log("✅ ride status = ", clickedRide.STATUS);

      switch (clickedRide.STATUS?.toLowerCase()) {
        case "requested":
          setRideProgress(1);
          break;
        case "accepted":
          setRideProgress(2);
          break;
        case "started":
          setRideProgress(3);
          break;
        case "material picked":
          setRideProgress(4);
          break;
        case "delivered":
          setRideProgress(5);
          break;
        case "completed":
          setRideProgress(6);
          break;
        default:
          setRideProgress(0);
      }
    } catch (err) {
      console.error("🚨 Error in fetchRideStatus:", err.message);
    }
  };

  const ProgressStep = ({ number, title, active, completed }) => {
    return (
      <div className="progress-step">
        <div
          className={`progress-circle ${active ? "active" : ""} ${
            completed ? "completed" : ""
          }`}
        >
          {completed ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 6L9 17l-5-5" />
            </svg>
          ) : (
            number
          )}
        </div>
        <div className={`progress-title ${active ? "active" : ""}`}>
          {title}
        </div>
      </div>
    );
  };

  const ProgressConnector = ({ active }) => {
    return (
      <div className={`progress-connector ${active ? "active" : ""}`}></div>
    );
  };

  const handleTimeClick = (value, type) => {
    if (type === "hour") {
      setSelectedHour(value);
      if (hourScrollRef.current) {
        hourScrollRef.current.scrollTo({
          top: value * 40,
          behavior: "smooth",
        });
      }
    } else {
      setSelectedMinute(value);
      if (minuteScrollRef.current) {
        minuteScrollRef.current.scrollTo({
          top: value * 40,
          behavior: "smooth",
        });
      }
    }
  };

  const handleConfirm = () => {
    if (!fromLocation || !toLocation) {
      toast.error("❌ Please select 'From' and 'To' locations.");
      return;
    }

    if (selectedHour === 0 && selectedMinute === 0) {
      setTimeError("Please select a time greater than 00h 00m");
      return;
    }

    setTimeError("");
    setShowConfirmation(true);
  };

  const handleYes = async () => {
    if (!currentUser || !currentUser.token_no) {
      toast.error("User not found");
      return;
    }

    if (isBooking) return;
    setIsBooking(true);

    const userId = currentUser.token_no;

    // ✅ Clean vehicle type (e.g., "Cherry Picker:1" → "Cherry Picker")
    const cleanVehicleType = vehicleType?.split(":")[0]?.trim();
    console.log("🚀 Checking vehicle type:", cleanVehicleType);

    // ✅ Check if any driver is assigned for this vehicle type
    try {
      const checkData = await apiFetch(
        `/api/drivers/check-assigned/${encodeURIComponent(cleanVehicleType)}`
      );

      const assignedCount = checkData.count || 0;

      if (assignedCount === 0) {
        toast.error(
          `No ${cleanVehicleType} drivers have been assigned yet. Please select another vehicle.`
        );
        setIsBooking(false);
        return;
      }
    } catch (err) {
      console.error("❌ Assignment check error:", err);
      toast.error("Could not verify driver assignment. Please try again.");
      setIsBooking(false);
      return;
    }

    // ✅ Proceed with booking
    setShowConfirmation(false);
    setRideStatus("requested");
    setRideProgress(0);
    setIsRequesting(true);
    localStorage.setItem("isRequesting", "true");

    const durationInMinutes = selectedHour * 60 + selectedMinute;

    try {
      const response = await bookRide(
        userId,
        fromLocation,
        toLocation,
        cleanVehicleType,
        "Special Task",
        durationInMinutes
      );

      if (response.rideId) {
        console.log(
          "✅ Special Task Ride booked successfully:",
          response.rideId
        );
        setRideId(response.rideId);
        localStorage.setItem("rideId", response.rideId);

        if (socket && socket.connected) {
          socket.emit("rideRequested", {
            rideId: response.rideId,
            fromLocation,
            toLocation,
            isSpecialTask: true,
          });
        }

        // ✅ CREATE NEW RIDE OBJECT FOR LOCAL STATE
        const newRideForState = {
          RIDE_ID: response.rideId,
          USER_ID: userId,
          FROM_LOCATION: fromLocation,
          TO_LOCATION: toLocation,
          STATUS: "requested",
          VEHICLE_TYPE: cleanVehicleType,
          RIDE_TYPE: "Special Task",
          DURATION: `${selectedHour}h ${selectedMinute}m`,
          TIMESTAMP: new Date().toISOString(),
          LOCAL_TIME: new Date().toLocaleString(),
        };

        // ✅ UPDATE LOCAL RIDE HISTORY IMMEDIATELY
        const updatedHistory = [newRideForState, ...rideHistory];
        setRideHistory(updatedHistory);
        localStorage.setItem("rideHistory", JSON.stringify(updatedHistory));

        const newRide = {
          rideId: response.rideId,
          userId,
          fromLocation,
          toLocation,
          status: "requested",
          estimatedTime,
          duration: `${selectedHour}h ${selectedMinute}m`,
          rideType: "Special Task",
          timestamp: new Date().toISOString(),
        };

        await apiFetch(`/api/ride-history/user?userId=${userId}`, {
          method: "POST",
          body: JSON.stringify(newRide),
        });

        console.log("📦 Ride history saved for Special Task");

        // ✅ FETCH UPDATED HISTORY FROM BACKEND AS WELL
        fetchRideHistory(userId);
      } else {
        toast.error("❌ Failed to book special task ride.");
        setRideStatus("");
      }
    } catch (error) {
      console.error("❌ API Error:", error);
      toast.error("❌ Error booking special task ride.");
      setRideStatus("");
    } finally {
      setIsBooking(false);
    }
  };

  const handleNo = () => {
    setShowConfirmation(false);
  };

  const toggleHistory = () => {
    setShowHistory(!showHistory);
  };

  // Updated formatDate function to use local_time if available
  const formatDate = (timestamp, localTime) => {
    // If local_time is available from backend, use it
    if (localTime) {
      return localTime;
    }
    // Otherwise, fallback to timestamp
    return timestamp || "";
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "completed":
        return "#10b981";
      case "ongoing":
        return "#3b82f6";
      case "requested":
        return "#f59e0b";
      default:
        return "#64748b";
    }
  };

  // Replace getInitialProgressFromStatus in SpecialTaskRide.js
  const getInitialProgressFromStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "requested":
        return 1;
      case "accepted":
        return 2;
      case "started":
        return 3;
      case "material picked":
        return 4;
      case "delivered":
        return 5;
      case "completed":
        return 6;
      default:
        return 0;
    }
  };

  const handleCancelRequest = async () => {
    try {
      if (rideId) {
        cancelRides(rideId);
      }

      if (socket) {
        socket.emit("removeRide", { rideId });
      }

      setRideStatus("");
      setFromLocation("");
      setToLocation("");
      setSearchFrom("");
      setSearchTo("");
      setSelectedHour(0);
      setSelectedMinute(0);
      setEstimatedTime(null);
      setRideProgress(0);
      setIsRequesting(false);
      localStorage.removeItem("isRequesting");

      localStorage.removeItem("rideId");
      localStorage.removeItem("driverDetails");

      navigate("/special-task-ride");
    } catch (error) {
      console.error("❌ Error cancelling ride:", error);
      toast.error("Failed to cancel ride.");
    }
  };

  // ✅ Extract cancel ride logic into a separate function
  const cancelRides = async (rideId) => {
    try {
      // Cancel booking
      await apiFetch(`/api/bookings/cancel/${rideId}`, { method: "DELETE" });

      // Update status in ride history
      // await apiFetch(`/api/ride-history/update-status/user/${rideId}`, {
      //   method: "PUT",
      //   body: { status: "cancelled" },
      // });

      // Update local state
      const updated = rideHistory.map((r) =>
        r.RIDE_ID === rideId ? { ...r, STATUS: "cancelled" } : r
      );
      setRideHistory(updated);
      localStorage.setItem("rideHistory", JSON.stringify(updated));

      // Inform socket
      if (socket) {
        socket.emit("removeRide", { rideId });
      }

      setConfirmCancelRideId(null);
    } catch (err) {
      console.error("❌ Error cancelling ride:", err);
      toast.error("Could not cancel ride.");
    }
  };

  return (
    <div className="special-task-container">
      <div className="special-task-btns">
        <button
          onClick={() => navigate("/requester")}
          style={{
            backgroundColor: "#007bff",
            color: "#fff",
            padding: "7px 9px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          ← Back
        </button>
        <LogoutButton />
      </div>

      {showConfetti && (
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          numberOfPieces={400}
          gravity={0.2}
          recycle={false}
        />
      )}

      <div className="header-container">
        <h2>Schedule Special Task Ride</h2>

        <div className="header-decoration"></div>
      </div>

      <div className="action-buttons">
        <button
          className={`history-button ${showHistory ? "active" : ""}`}
          onClick={toggleHistory}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 3v18h18"></path>
            <path d="M18 17V9"></path>
            <path d="M13 17V5"></path>
            <path d="M8 17v-3"></path>
          </svg>
          {showHistory ? "Hide History" : "Task History"}
        </button>

        {rideProgress > 1 && driverDetails && (
          <button
            className="history-button"
            style={{
              marginLeft: "10px",
              backgroundColor: "#10b981",
              color: "white",
              padding: "8px 12px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
            onClick={() => setShowDriverPopup(true)}
          >
            👤 Driver Details
          </button>
        )}
      </div>

      {showHistory && (
        <div className="ride-history-container">
          <h3>Your Special Task History</h3>
          {rideHistory.length > 0 ? (
            <div className="history-list">
              {rideHistory.map((ride, index) => (
                <div
                  key={index}
                  className={`history-item ${
                    ride.rideType === "Special Task"
                      ? "special-task"
                      : "regular-task"
                  }`}
                  style={{ position: "relative" }} // Required for absolute child positioning
                  onClick={() => {
                    setRideId(ride.RIDE_ID);
                    rideIdRef.current = ride.RIDE_ID;
                    setRideProgress(fetchRideStatus(ride.RIDE_ID));
                    setShowHistory(false);
                    fetchRideTimestamps(ride.RIDE_ID);
                  }}
                >
                  <div className="history-route">
                    <span className="from-location">{ride.FROM_LOCATION}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#64748b"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14"></path>
                      <path d="M12 5l7 7-7 7"></path>
                    </svg>
                    <span className="to-location">{ride.TO_LOCATION}</span>
                  </div>

                  <div className="ride-id-label">Ride ID: {ride.RIDE_ID}</div>

                  <div className="history-details">
                    <span className="history-time">{ride.DURATION}</span>
                    <span
                      className="history-status"
                      style={{ backgroundColor: getStatusColor(ride.STATUS) }}
                    >
                      {ride.STATUS}
                    </span>
                    <span className="history-date">
                      {(() => {
                        const timestamps = rideTimestamps[ride.RIDE_ID];
                        if (!timestamps)
                          return formatDate(ride.TIMESTAMP, ride.LOCAL_TIME);
                        if (timestamps.end_time)
                          return new Date(timestamps.end_time).toLocaleString();
                        if (timestamps.material_drop_time)
                          return new Date(
                            timestamps.material_drop_time
                          ).toLocaleString();
                        if (timestamps.material_pick_time)
                          return new Date(
                            timestamps.material_pick_time
                          ).toLocaleString();
                        if (timestamps.start_time)
                          return new Date(
                            timestamps.start_time
                          ).toLocaleString();
                        if (timestamps.creation_time)
                          return new Date(
                            timestamps.creation_time
                          ).toLocaleString();
                        return formatDate(ride.TIMESTAMP, ride.LOCAL_TIME);
                      })()}
                    </span>
                  </div>

                  {/* ✅ Vehicle Type Display */}
                  <div
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "40%",
                      transform: "translateY(-50%)",
                      fontSize: "0.85rem",
                      fontWeight: "bold",
                      color: "#4b5563",
                    }}
                  >
                    {ride.VEHICLE_TYPE || ride.vehicle_type || "N/A"}
                  </div>

                  {ride.STATUS === "requested" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "8px",
                      }}
                    >
                      {confirmCancelRideId === ride.RIDE_ID ? (
                        <div
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "8px",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              marginBottom: "6px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              fill="none"
                              stroke="#ef4444"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              viewBox="0 0 24 24"
                            >
                              <circle cx="12" cy="12" r="10" />
                              <line x1="12" y1="8" x2="12" y2="12" />
                              <line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            <span
                              style={{ fontSize: "14px", color: "#111827" }}
                            >
                              Are you sure you want to cancel this ride?
                            </span>
                          </div>
                          <div style={{ display: "flex", gap: "6px" }}>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                cancelRides(ride.RIDE_ID);
                              }}
                              style={{
                                backgroundColor: "#ef4444",
                                color: "white",
                                padding: "4px 10px",
                                borderRadius: "4px",
                                fontSize: "12px",
                              }}
                            >
                              Yes
                            </button>

                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setConfirmCancelRideId(null);
                              }}
                              style={{
                                backgroundColor: "#e5e7eb",
                                color: "#111827",
                                padding: "4px 10px",
                                borderRadius: "4px",
                                fontSize: "12px",
                              }}
                            >
                              No
                            </button>
                          </div>
                        </div>
                      ) : (
                        <button
                          className="cancel-ride-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            setConfirmCancelRideId(ride.RIDE_ID);
                          }}
                          style={{
                            backgroundColor: "#ef4444",
                            color: "white",
                            padding: "4px 10px",
                            borderRadius: "4px",
                            fontSize: "12px",
                          }}
                        >
                          Cancel Ride
                        </button>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="no-history">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#64748b"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <p>No special task history found</p>
            </div>
          )}
        </div>
      )}

      <div className="booking-form">
        {showConfirmation && (
          <animated.div
            className="confirmation-overlay"
            style={confirmationSpring}
          >
            <div className="confirmation-box">
              <div className="confirmation-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#3498db"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
                  <line x1="9" y1="9" x2="9.01" y2="9"></line>
                  <line x1="15" y1="9" x2="15.01" y2="9"></line>
                </svg>
              </div>
              <h3>Confirm Special Task Ride</h3>
              <p>
                You're requesting transport from <strong>{fromLocation}</strong>{" "}
                to <strong>{toLocation}</strong> for{" "}
                <strong>
                  {selectedHour}h {selectedMinute}m
                </strong>
                .
              </p>
              {timeError && <div className="error-message">{timeError}</div>}
              <div className="confirmation-buttons">
                <button
                  className="yes-button"
                  onClick={handleYes}
                  disabled={isBooking}
                >
                  {isBooking ? "Processing..." : "Confirm Request"}
                </button>

                <button className="no-button" onClick={handleNo}>
                  Cancel
                </button>
              </div>
            </div>
          </animated.div>
        )}

        {!showHistory && (
          <>
            {rideProgress > 0 && (
              <div className="ride-progress-tracker">
                <h3>Ride Status for Ride ID: {rideId}</h3>

                {/* Real-time reassignment status */}
                {isWaitingForReassignment && (
                  <div className="reassignment-status">
                    <div className="loading-spinner"></div>
                    <p
                      style={{
                        color: "#f59e0b",
                        fontWeight: "bold",
                        margin: "10px 0",
                      }}
                    >
                      {reassignmentMessage}
                    </p>
                  </div>
                )}

                {reassignmentMessage && !isWaitingForReassignment && (
                  <div className="reassignment-success">
                    <p
                      style={{
                        color: "#10b981",
                        fontWeight: "bold",
                        margin: "10px 0",
                      }}
                    >
                      ✅ {reassignmentMessage}
                    </p>
                  </div>
                )}

                <h3>Ride Status</h3>
                <div className="progress-steps">
                  <div className="progress-item">
                    <ProgressStep
                      number={1}
                      title="Requested"
                      active={rideProgress === 1}
                      completed={rideProgress > 1}
                    />
                    {rideTimestamps[rideId]?.creation_time && (
                      <div className="timestamp-label">
                        {formatDate(rideTimestamps[rideId].creation_time)}
                      </div>
                    )}
                  </div>

                  <ProgressConnector active={rideProgress > 1} />

                  <div className="progress-item">
                    <ProgressStep
                      number={2}
                      title="Driver Assigned"
                      active={rideProgress === 2}
                      completed={rideProgress > 2}
                    />
                    {rideTimestamps[rideId]?.creation_time && (
                      <div className="timestamp-label">
                        {formatDate(rideTimestamps[rideId].creation_time)}
                      </div>
                    )}
                  </div>

                  <ProgressConnector active={rideProgress > 2} />

                  <div className="progress-item">
                    <ProgressStep
                      number={3}
                      title="Ride Started"
                      active={rideProgress === 3}
                      completed={rideProgress > 3}
                    />
                    {rideTimestamps[rideId]?.start_time && (
                      <div className="timestamp-label">
                        {formatDate(rideTimestamps[rideId].start_time)}
                      </div>
                    )}
                  </div>

                  <ProgressConnector active={rideProgress > 3} />

                  <div className="progress-item">
                    <ProgressStep
                      number={4}
                      title="Material Picked"
                      active={rideProgress === 4}
                      completed={rideProgress > 4}
                    />
                    {rideTimestamps[rideId]?.material_pick_time && (
                      <div className="timestamp-label">
                        {formatDate(rideTimestamps[rideId].material_pick_time)}
                      </div>
                    )}
                  </div>

                  <ProgressConnector active={rideProgress > 4} />

                  <div className="progress-item">
                    <ProgressStep
                      number={5}
                      title="Delivered"
                      active={rideProgress === 5}
                      completed={rideProgress > 5}
                    />
                    {rideTimestamps[rideId]?.material_drop_time && (
                      <div className="timestamp-label">
                        {formatDate(rideTimestamps[rideId].material_drop_time)}
                      </div>
                    )}
                  </div>

                  <ProgressConnector active={rideProgress > 5} />

                  <div className="progress-item">
                    <ProgressStep
                      number={6}
                      title="Task Ended"
                      active={rideProgress === 6}
                      completed={rideProgress > 6}
                    />
                    {rideTimestamps[rideId]?.end_time && (
                      <div className="timestamp-label">
                        {formatDate(rideTimestamps[rideId].end_time)}
                      </div>
                    )}
                  </div>
                </div>

                {/* ✅ Book New Ride Button */}
                <button
                  className="confirm-button"
                  onClick={() => navigate("/requester")}
                  style={{ marginTop: "20px" }}
                >
                  Book New Special Task
                </button>
              </div>
            )}
            {/* 
{driverDetails && (
  <div className="driver-details-box">
    <h3>Assigned Driver Details</h3>
    <p><strong>Name:</strong> {driverDetails?.NAME || driverDetails?.name || "N/A"}</p>
    <p><strong>Mobile:</strong> {driverDetails?.MOBILE || driverDetails?.mobile || "N/A"}</p>
    <p><strong>Vehicle:</strong> {driverDetails?.VEHICLE || driverDetails?.vehicle || "N/A"}</p>
  </div>
)} */}

            {rideProgress === 0 && (
              <>
                <div className="form-group">
                  <label>Pickup Location</label>
                  <div className="location-input-container">
                    <div className="location-input-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#3b82f6"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="12" cy="10" r="3" />
                        <path d="M12 2a8 8 0 0 0-8 8c0 1.892.402 3.13 1.5 4.5L12 22l6.5-7.5c1.098-1.37 1.5-2.608 1.5-4.5a8 8 0 0 0-8-8z" />
                      </svg>
                    </div>
                    <input
                      type="text"
                      placeholder="Where to pick up materials?"
                      className="location-search-input"
                      value={fromLocation || searchFrom}
                      onChange={(e) => {
                        setFromLocation("");
                        setSearchFrom(e.target.value);
                      }}
                      onFocus={() => setShowFromDropdown(true)}
                      onBlur={() =>
                        setTimeout(() => setShowFromDropdown(false), 200)
                      }
                    />
                    {fromLocation && (
                      <button
                        className="clear-location-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setFromLocation("");
                          setSearchFrom("");
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#64748b"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                      </button>
                    )}
                  </div>
                  {showFromDropdown && filteredFromLocations.length > 0 && (
                    <div className="location-dropdown">
                      {filteredFromLocations.map((loc, index) => (
                        <div
                          key={`from-${index}`}
                          className="location-dropdown-item"
                          tabIndex="0"
                          onMouseDown={() => {
                            setFromLocation(loc);
                            setSearchFrom("");
                            setShowFromDropdown(false);
                          }}
                        >
                          <div className="location-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#64748b"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <circle cx="12" cy="10" r="3" />
                              <path d="M12 2a8 8 0 0 0-8 8c0 1.892.402 3.13 1.5 4.5L12 22l6.5-7.5c1.098-1.37 1.5-2.608 1.5-4.5a8 8 0 0 0-8-8z" />
                            </svg>
                          </div>
                          <div className="location-text">{loc}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>Drop Location</label>
                  <div className="location-input-container">
                    <div className="location-input-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ef4444"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                    </div>
                    <input
                      type="text"
                      placeholder="Where to deliver materials?"
                      className="location-search-input"
                      value={toLocation || searchTo}
                      onChange={(e) => {
                        setToLocation("");
                        setSearchTo(e.target.value);
                      }}
                      onFocus={() => setShowToDropdown(true)}
                      onBlur={() =>
                        setTimeout(() => setShowToDropdown(false), 200)
                      }
                      disabled={!fromLocation}
                    />
                    {toLocation && (
                      <button
                        className="clear-location-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setToLocation("");
                          setSearchTo("");
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#64748b"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                      </button>
                    )}
                  </div>
                  {showToDropdown && filteredToLocations.length > 0 && (
                    <div className="location-dropdown">
                      {filteredToLocations.map((loc, index) => (
                        <div
                          key={`to-${index}`}
                          className="location-dropdown-item"
                          tabIndex="0"
                          onMouseDown={() => {
                            setToLocation(loc);
                            setSearchTo("");
                            setShowToDropdown(false);
                          }}
                        >
                          <div className="location-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#64748b"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                              <circle cx="12" cy="10" r="3"></circle>
                            </svg>
                          </div>
                          <div className="location-text">{loc}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>Vehicle Type</label>
                  <div className="location-input-container">
                    <div className="location-input-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#3b82f6"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 9h14V5H5z" />
                        <path d="M15 3v2" />
                        <path d="M9 3v2" />
                        <path d="M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z" />
                      </svg>
                    </div>
                    <select
                      className="location-search-input"
                      value={vehicleType}
                      onChange={(e) => setVehicleType(e.target.value)}
                    >
                      {vehicleOptions.map((vehicle) => (
                        <option key={vehicle} value={vehicle}>
                          {vehicle}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {estimatedTime && (
                  <div className="estimated-time-card">
                    <div className="time-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#3b82f6"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                    </div>
                    <div className="time-details">
                      <div className="time-label">Estimated travel time</div>
                      <div className="time-value">{estimatedTime} minutes</div>
                    </div>
                  </div>
                )}

                <div className="time-selection-container">
                  <h3 className="time-selection-title">Select Duration</h3>

                  <div className="time-selection">
                    <div className="time-column">
                      <h4>Hours</h4>
                      <div ref={hourScrollRef} className="time-scroll">
                        {hours.map((hour) => (
                          <div
                            key={hour}
                            className={`time-item ${
                              hour === selectedHour ? "selected" : ""
                            }`}
                            onClick={() => handleTimeClick(hour, "hour")}
                          >
                            {hour.toString().padStart(2, "0")}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="time-separator">:</div>

                    <div className="time-column">
                      <h4>Minutes</h4>
                      <div ref={minuteScrollRef} className="time-scroll">
                        {minutes.map((minute) => (
                          <div
                            key={minute}
                            className={`time-item ${
                              minute === selectedMinute ? "selected" : ""
                            }`}
                            onClick={() => handleTimeClick(minute, "minute")}
                          >
                            {minute.toString().padStart(2, "0")}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="selected-time-display">
                    <span className="time-value">
                      {selectedHour.toString().padStart(2, "0")}
                    </span>
                    <span className="time-label">h</span>
                    <span className="time-value">
                      {selectedMinute.toString().padStart(2, "0")}
                    </span>
                    <span className="time-label">m</span>
                  </div>
                </div>

                {timeError && <div className="error-message">{timeError}</div>}

                {rideStatus === "requested" && isRequesting ? (
                  <button
                    className="cancel-button"
                    onClick={() => setShowCancelConfirmation(true)}
                    style={{
                      backgroundColor: "#ef4444",
                      color: "#fff",
                      padding: "10px 16px",
                      borderRadius: "8px",
                      marginTop: "20px",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Cancel Request
                  </button>
                ) : (
                  <button
                    className={`confirm-button ${
                      !fromLocation || !toLocation ? "disabled" : ""
                    }`}
                    onClick={handleConfirm}
                    disabled={!fromLocation || !toLocation}
                  >
                    <button
                      className={`confirm-button ${
                        !fromLocation || !toLocation ? "disabled" : ""
                      }`}
                      onClick={handleConfirm}
                      disabled={!fromLocation || !toLocation}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="2 -5 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginRight: "6px" }}
                      >
                        <path d="M5 12h14"></path>
                        <path d="M12 5l7 7-7 7"></path>
                      </svg>
                      Schedule Special Task
                    </button>
                  </button>
                )}
              </>
            )}

            {rideProgress > 0 && (
              <div
                className={`ride-status ${
                  rideProgress === 4 ? "success" : "info"
                }`}
              >
                {rideProgress === 0 && (
                  <button
                    className="cancel-button"
                    onClick={handleCancelRequest}
                    style={{
                      backgroundColor: "#ef4444",
                      color: "white",
                      padding: "10px 15px",
                      marginTop: "10px",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                  >
                    Cancel Request
                  </button>
                )}
                <>
                  <h3>Driver Assigned!</h3>
                  <p>Your driver is on the way to {fromLocation}.</p>
                  <p className="status-note">
                    Estimated arrival: {estimatedTime} minutes
                  </p>
                </>
                ){rideProgress === 2 && <></>}
                {rideProgress === 3 && <></>}
                {rideProgress === 4 && <></>}
              </div>
            )}
          </>
        )}

        {showCancelConfirmation && (
          <div className="confirmation-overlay">
            <div className="confirmation-box">
              <h3>Are you sure you want to cancel this ride?</h3>
              <div className="confirmation-buttons">
                <button
                  className="yes-button"
                  onClick={() => {
                    handleCancelRequest();
                    setShowCancelConfirmation(false);
                  }}
                >
                  Yes
                </button>
                <button
                  className="no-button"
                  onClick={() => setShowCancelConfirmation(false)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {showDriverPopup && (
        <div className="confirmation-overlay">
          <div className="confirmation-box" style={{ position: "relative" }}>
            <button
              onClick={() => setShowDriverPopup(false)}
              className="close-popup-button"
            >
              ✕
            </button>

            <h3>Driver Details</h3>
            <p>
              <strong>Name:</strong>{" "}
              {driverDetails?.NAME || driverDetails?.name || "N/A"}
            </p>
            <p>
              <strong>Mobile:</strong>{" "}
              {driverDetails?.MOBILE || driverDetails?.mobile || "N/A"}{" "}
              <a
                href={`tel:${
                  driverDetails?.MOBILE || driverDetails?.mobile || ""
                }`}
                style={{
                  marginLeft: "10px",
                  textDecoration: "none",
                  fontWeight: "bold",
                  color: "#10b981",
                }}
              >
                📞
              </a>
            </p>
            <p>
              <strong>Vehicle:</strong>{" "}
              {driverDetails?.VEHICLE || driverDetails?.vehicle || "Forklift"}
            </p>

            <p>
              <strong>From:</strong>{" "}
              {rideHistory.find((r) => r.RIDE_ID === rideId)?.FROM_LOCATION ||
                "Loading Point"}
            </p>

            <p>
              <strong>To:</strong>{" "}
              {rideHistory.find((r) => r.RIDE_ID === rideId)?.TO_LOCATION ||
                "Destination"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpecialTaskRide;
